import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { Validators, FormControl } from "@angular/forms";
import { CommonFunctionService ,UserPOSData} from "../../../../services/Common/common-function.service";
import { TenderTipTaxService } from 'src/app/POS/POSServices/Setup/tender-tip-tax.service';

 const swal = require('sweetalert');

@Component({
  selector: 'app-tender',
  templateUrl: './tender.component.html',
  styleUrls: ['./tender.component.scss']
})
export class TenderComponent implements OnInit {
  merchantdata: UserPOSData ;
  Type = [
    { text: "Cash", value: "Cash" },
    { text: "CreditCard", value: "CreditCard" },
    { text: "DebitCard", value: "DebitCard" },
    { text: "Wallet", value: "Wallet" },
    { text: "Upi", value: "Upi" },
    { text: "StoredCard", value: "StoredCard" },
    { text: "NetBanking", value: "NetBanking" },
    { text: "BharatQrCode", value: "BharatQrCode" },
    { text: "PrePaidCard", value: "PrePaidCard" },
  
  ];
  isTenderType: boolean = false;
  dateTime;
  isNewtender: boolean = true;
  isUpdatetender: boolean = false;
  rows;
  tender;

 
  TenderName = new FormControl("", [Validators.required]);
  TenderType = new FormControl("", [ Validators.required, Validators.pattern("^(?![a-zA-Z ])+[0-9]+((?![a-zA-Z@#$%^&*,()! ]).[0-9]{1,2})?$")]);
  TenderAccepted: boolean = false;
  OpenCashDrawer: boolean = false;
id= new FormControl("", [Validators.required]);
ContactPerference  = new FormControl("", [Validators.required]);
  constructor(
    private router: Router,
    private commonfunction: CommonFunctionService,
    private service: TenderTipTaxService,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
     this.merchantdata = this.commonfunction.getUserPOSData();
    this.gettenderDetails();
  }

  TenderAccepted1()
  {
    this.TenderAccepted=!this.TenderAccepted
    

  }
  OpenCashDrawer1()
  {
    this.OpenCashDrawer=!this.OpenCashDrawer

  }

  gettenderDetails() {
    let form = { merchantKeyId: "", id: "", PosSubscriptionId:"" };
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
       form.id = params["id"];
      form.merchantKeyId = params["merchantKeyId"];
      form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);
    });   

    this.service.GetTenderDetail(form).subscribe(result => {   
      console.log("result.Id---" + result);
      if (result.Id> 0) {
        this.dateTime=result.dateTime;
   this.TenderAccepted=result.TenderAccepted
 
   if(result.TenderType==0)
   {
     this.tender="Cash";
   }
   else if(result.TenderType==1)
   {
    this.tender="CreditCard";
   }
   else if(result.TenderType==2)
   {
          this.tender="DebitCard"
   }
   else if(result.TenderType==3)
   {
    this.tender="Wallet";
   }
   else if(result.TenderType==4)
   {
    this.tender="Upi";
   }
   else if(result.TenderType==5)
   {
    this.tender="StoredCard";
   }
   else if(result.TenderType==6)
   {
    this.tender="NetBanking";
   }
   else if(result.TenderType==7)
   {
    this.tender="BharatQrCode";
   }
   else if(result.TenderType==8)
   {
    this.tender="PrePaidCard";
   }

    this.OpenCashDrawer=result.OpenCashDrawer
        this.isUpdatetender = true;
        this.isNewtender = false;
        this.rows = result;
      } else {
        this.isUpdatetender = false;
        this.isNewtender = true;
      }
    });

  }


  onChange()
  {
    let form = { merchantKeyId: "", id:"", PosSubscriptionId:"" };
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
      // form.id = params["id"];
  
      form.id = this.TenderType.value;
      form.merchantKeyId = params["merchantKeyId"];
      form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);
    });   

    this.service.GetTenderDetailid(form).subscribe(result => {   
      // console.log("result.Id---" + result);
      if(result==null)
      {
        this.isTenderType=false;
      }
      else{
       var tendertype=this.TenderType.value;
       var rtender=result.TenderType;
      //  if(tendertype==rtender)
      //  {
      //       this.isTenderType=true;
      //  }
      
      }
    });
 
  }

 



  newtender() {
   
    let form = {
      PosSubscriptionId:"",
      TenderName:"",
      TenderType:"",
      TenderAccepted:false,
      OpenCashDrawer:false,
      
      };
    form.TenderName = this.TenderName.value;
    form.TenderType = this.TenderType.value;
    form.TenderType = this.TenderType.value;
    if(form.TenderType=="Cash")
    {
      form.TenderType="0"
    }
    else if(form.TenderType=="CreditCard")
    {
      form.TenderType="1"
    }
    else if(form.TenderType=="DebitCard")
    {
      form.TenderType="2"
    }
    else if(form.TenderType=="Wallet")
    {
      form.TenderType="3"
    }
    else if(form.TenderType=="Upi")
    {
      form.TenderType="4"
    }
    else if(form.TenderType=="StoredCard")
    {
      form.TenderType="5"
    }
    else if(form.TenderType=="NetBanking")
    {
      form.TenderType="6"
    }
    else if(form.TenderType=="BharatQrCode")
    {
      form.TenderType="7"
    }
    else if(form.TenderType=="PrePaidCard")
    {
      form.TenderType="8"
    }
    form.TenderAccepted = this.TenderAccepted;
    form.OpenCashDrawer = this.OpenCashDrawer;
    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    // form.CustomerId = merchantdata.PosSubscriptionId;
    form.PosSubscriptionId = merchantdata.PosSubscriptionId;
    // alert(this.requestDate.value);
    // alert(this.dueDate.value);
    this.service.AddTender(form).subscribe(result => {
      console.log(" result - ", result);
      if (result != null) {
        // this.dialog.open(SuccessPopupComponent, {
        //   data: "Payment Type Added Successfully !1"
        // });
        swal("Added", "Payment Type Added Successfully ", "success"); 
        this.router.navigate(["/pos/tender/manage"]);
    }
    });
  }

  Updatetender()
  {
    let form = {
      Id:"",
      PosSubscriptionId:"",
      TenderName:"",
      TenderType:"",
      TenderAccepted:false,
      OpenCashDrawer:false,
      DateTime:"",
      };
      form.Id=this.id.value;
    form.TenderName = this.TenderName.value;
    form.TenderType = this.TenderType.value;
    form.TenderType = this.TenderType.value;
    if(form.TenderType=="Cash")
    {
      form.TenderType="0"
    }
    else if(form.TenderType=="CreditCard")
    {
      form.TenderType="1"
    }
    else if(form.TenderType=="DebitCard")
    {
      form.TenderType="2"
    }
    else if(form.TenderType=="Wallet")
    {
      form.TenderType="3"
    }
    else if(form.TenderType=="Upi")
    {
      form.TenderType="4"
    }
    else if(form.TenderType=="StoredCard")
    {
      form.TenderType="5"
    }
    else if(form.TenderType=="NetBanking")
    {
      form.TenderType="6"
    }
    else if(form.TenderType=="BharatQrCode")
    {
      form.TenderType="7"
    }
    else if(form.TenderType=="PrePaidCard")
    {
      form.TenderType="8"
    }
    form.TenderAccepted = this.TenderAccepted;
    form.OpenCashDrawer = this.OpenCashDrawer;
    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    // form.CustomerId = merchantdata.PosSubscriptionId;
    form.PosSubscriptionId = merchantdata.PosSubscriptionId;
    form.DateTime=this.dateTime;
    // alert(this.requestDate.value);
    // alert(this.dueDate.value);
    this.service.UpdateTender(form).subscribe(result => {
      console.log(" result - ", result);
      if (result != null) {
        // this.dialog.open(SuccessPopupComponent, {
        //   data: "Payment Type Updated Successfully !1"
        // });
        swal("Updated", "Payment Type Updated Successfully ", "success"); 
        this.router.navigate(["/pos/tender/manage"]);
      }
    });
  }
  tendernameError() {
      return this.TenderName.hasError("required") ? "Payment Name is required"
        : this.TenderName.hasError("pattern") ? "Payment Name should be allow only alphabets" : "";
    }
  
  tendertypeerrors() {
      return this.TenderType.hasError("required") ? "PaymentType is required"
        : this.TenderType.hasError("pattern") ? "" : "";
    }

}
